export default `.ids-progress-chart {
  contain: content;
  display: flex;
  flex-direction: column;
  font-family: var(--ids-progress-chart-font-family);
  margin: var(--ids-progress-chart-margin);
}
.ids-progress-chart .labels {
  display: inline-flex;
  flex-direction: row;
  align-items: flex-end;
  color: var(--ids-progress-chart-label-color-text);
  font-size: var(--ids-progress-chart-label-font-size);
  margin-bottom: var(--ids-progress-chart-label-margin-bottom);
  position: relative;
  width: 100%;
}
.ids-progress-chart .labels .label-main {
  display: inline-flex;
  margin-inline-end: var(--ids-space-2xs);
}
.ids-progress-chart .labels .label-main::part(text) {
  color: currentColor;
  font-family: inherit;
  font-size: inherit;
}
.ids-progress-chart .labels .label-progress {
  display: inline-flex;
  margin: var(--ids-progress-chart-label-progress-margin);
}
.ids-progress-chart .labels .label-progress::part(text) {
  color: currentColor;
  font-family: inherit;
  font-size: inherit;
}
.ids-progress-chart .labels .label-end {
  display: flex;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  justify-content: flex-end;
}
.ids-progress-chart .labels .label-total {
  position: absolute;
}
.ids-progress-chart .labels .label-total::part(text) {
  color: currentColor;
  font-family: inherit;
  font-size: inherit;
}
.ids-progress-chart .bar {
  border-radius: var(--ids-progress-chart-bar-border-radius);
  min-height: var(--ids-progress-chart-height-min);
  min-width: var(--ids-progress-chart-bar-width-min);
  display: flex;
  position: relative;
}
.ids-progress-chart .bar .bar-total {
  background-color: var(--ids-progress-chart-total-color-background);
  border-radius: inherit;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: inherit;
}
.ids-progress-chart .bar .bar-progress {
  background-color: var(--ids-progress-chart-bar-progress-color-background);
  border-radius: inherit;
  display: flex;
  top: 0;
  left: 0;
  height: inherit;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
